import { NoddiIcon } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import { WheelSetStatus, WheelSetStatusType } from 'noddi-web';
import { getCommonTranslations } from '../../../utils/commonTranslations';

type Props = {
  status: WheelSetStatusType;
};

export const WheelSetStatusBadge = ({ status }: Props) => {
  const translations = getCommonTranslations().wheelMeasurements;

  switch (status) {
    case WheelSetStatus.Satisfactory:
      return (
        <NoddiBadge variant='success' className='gap-1'>
          <NoddiIcon name='Check' size='small' />
          {translations.inAGoodCondition}
        </NoddiBadge>
      );
    case WheelSetStatus.SoonWornOut:
      return (
        <NoddiBadge variant='warning' className='gap-1'>
          <NoddiIcon name='Info' size='small' />
          {translations.soonWornOut}
        </NoddiBadge>
      );
    case WheelSetStatus.WornOut:
      return (
        <NoddiBadge variant='destructive' className='gap-1'>
          <NoddiIcon name='X' size='small' />
          {translations.wornOut}
        </NoddiBadge>
      );
    case WheelSetStatus.MissingMeasurements:
    default:
      return (
        <NoddiBadge variant='outline' className='gap-1'>
          <NoddiIcon name='Info' size='small' />
          {translations.missingMeasurements}
        </NoddiBadge>
      );
  }
};
